import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import style from './Footer.module.scss'
import commonStyle from '../../style.module.scss'

export interface IFooterProps {
  showCart: boolean
  showProduct: boolean
  amount: number
  findability: boolean
  onCartOpen: () => void
  onHomeClick: () => void
  showHint: () => void
  closeSimulation: () => void
}

const Footer = ({
  showCart,
  showProduct,
  amount,
  findability,
  onCartOpen,
  onHomeClick,
  showHint,
  closeSimulation
}: IFooterProps) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {viewport.mobile ? (
        <footer className={style.footerMobile}>
          <button
            className={`${style.item} ${!showCart && !showProduct ? style.itemActive : ''}`}
            onClick={onHomeClick}
          >
            <div className={style.iconHome} />
            <div className={style.text}>{t('questions', 'ec', 'target', 'discover')}</div>
          </button>
          <EmptyLink color="#CC0000">
            <div className={style.item}>
              <div className={style.iconEssentials} />
              <div className={style.text}>{t('questions', 'ec', 'target', 'essentials')}</div>
            </div>
          </EmptyLink>
          {findability ? (
            <EmptyLink color="#CC0000">
              <div className={style.item}>
                <div className={style.iconCart} />
                <div className={style.text}>{t('questions', 'ec', 'target', 'cart')}</div>
              </div>
            </EmptyLink>
          ) : (
            <button className={`${style.item} ${showCart ? style.itemActive : ''}`} onClick={onCartOpen}>
              <div className={style.amount}>{amount > 99 ? '99+' : amount}</div>
              <div className={style.iconCart} />
              <div className={style.text}>{t('questions', 'ec', 'target', 'cart')}</div>
            </button>
          )}
          <>
            <div className={style.item}>
              <div className={`${commonStyle.IconAytmPlace} ${style.aytmItem}`}>
                <i className=" icon-aytmfd-help" onClick={showHint} />
              </div>
            </div>
          </>
          <>
            <div className={style.item}>
              <div className={`${commonStyle.IconAytmPlace} ${style.aytmItem}`}>
                <i className=" icon-aytmfd-exit" onClick={closeSimulation} />
              </div>
            </div>
          </>
        </footer>
      ) : (
        <footer className={style.footer}>
          <div className={style.warning}>
            <EmptyLink color="#CC0000">
              <strong>{t('questions', 'ec', 'target', 'seeDetails')}&nbsp;</strong>
              <span>{t('questions', 'ec', 'target', 'restrictionsApply')}</span>
            </EmptyLink>
          </div>
          <div className={style.columns}>
            <div className={style.inner}>
              <div className={style.column}>
                <div className={style.title}>{t('questions', 'ec', 'target', 'aboutUs')}</div>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'aboutTarget')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'careers')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'newsBlog')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'targetBrands')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'bullseye')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'governance')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'press')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'advWith')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'invest')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'affilate')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'suppliers')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'targetPlus')}</div>
                </EmptyLink>
              </div>
              <div className={style.column}>
                <div className={style.title}>{t('questions', 'ec', 'target', 'help')}</div>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'targetHelp')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'returns')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'track')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'recalls')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'contactUs')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'feedback')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'accessibility')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'security')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'team')}</div>
                </EmptyLink>
              </div>
              <div className={style.column}>
                <div className={style.title}>{t('questions', 'ec', 'target', 'stores')}</div>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="StoreAvailability">
                      <path fill="#C00" d="M4 28h16V4H4z" />
                      <path fill="#fff" d="M12 12a1.33 1.33 0 1 0 0-2.67A1.33 1.33 0 0 0 12 12" />
                      <path
                        fill="#fff"
                        d="M16 10.67a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.33 0a2.67 2.67 0 1 0-5.34 0 2.67 2.67 0 0 0 5.34 0"
                      />
                      <path fill="#CEAF8C" d="M9.33 28H28V17.33H9.33z" />
                      <path fill="#333" d="M18 28v-6.67h-4.67V28zm6 0v-6.67h-4.67V28z" />
                    </svg>
                    {t('questions', 'ec', 'target', 'findStore')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.01" width="24" height="24" fill="white" />
                      <path
                        d="M22.2517 7.39002L18.61 3.7483C18.1111 3.24943 17.4626 3 16.8141 3C16.1655 3 15.517 3.24943 14.9683 3.7483L11.9751 6.7415L8.98186 3.7483C8.48299 3.24943 7.83447 3 7.18594 3C6.53742 3 5.88889 3.24943 5.39002 3.7483L1.7483 7.39002C0.750567 8.38775 0.750567 10.034 1.7483 11.0317L12.0249 21.3084L22.2517 11.0317C23.2494 10.034 23.2494 8.38775 22.2517 7.39002Z"
                        fill="#CC0000"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'clinic')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.01" width="24" height="24" fill="white" />
                      <path
                        d="M22.2517 7.39002L18.61 3.7483C18.1111 3.24943 17.4626 3 16.8141 3C16.1655 3 15.517 3.24943 14.9683 3.7483L11.9751 6.7415L8.98186 3.7483C8.48299 3.24943 7.83447 3 7.18594 3C6.53742 3 5.88889 3.24943 5.39002 3.7483L1.7483 7.39002C0.750567 8.38775 0.750567 10.034 1.7483 11.0317L12.0249 21.3084L22.2517 11.0317C23.2494 10.034 23.2494 8.38775 22.2517 7.39002Z"
                        fill="#CC0000"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'pharmacy')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.01" width="24" height="24" fill="white" />
                      <path
                        d="M22.2517 7.39002L18.61 3.7483C18.1111 3.24943 17.4626 3 16.8141 3C16.1655 3 15.517 3.24943 14.9683 3.7483L11.9751 6.7415L8.98186 3.7483C8.48299 3.24943 7.83447 3 7.18594 3C6.53742 3 5.88889 3.24943 5.39002 3.7483L1.7483 7.39002C0.750567 8.38775 0.750567 10.034 1.7483 11.0317L12.0249 21.3084L22.2517 11.0317C23.2494 10.034 23.2494 8.38775 22.2517 7.39002Z"
                        fill="#CC0000"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'optical')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'moreInStore')}</div>
                </EmptyLink>
              </div>

              <div className={style.column}>
                <div className={style.title}>{t('questions', 'ec', 'target', 'services')}</div>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Circle">
                      <path fill="#288186" d="M16 29.33a13.33 13.33 0 1 0 0-26.66 13.33 13.33 0 0 0 0 26.66" />
                      <path
                        fill="#fff"
                        d="M17.9 2.8a67 67 0 0 0-3.71 5.89h-.01l4.78.59c.38-.65 1.35-3.45 1.82-5.74a13 13 0 0 0-2.88-.75"
                      />
                      <path
                        fill="#BBB"
                        d="M19.37 8.12a7 7 0 0 0-1.67-.29 5 5 0 0 0-1.66.18q.81.21 1.59.38.77.2 1.52.42h.03l.27-.67z"
                      />
                      <path
                        fill="#fff"
                        d="M27.7 9.6c-2.65.84-5.44 2.64-5.44 2.64l-1.54 7.81c3.44.36 6.54-1.66 8.61-4.04v-.02c0-2.32-.59-4.5-1.63-6.4"
                      />
                      <path
                        fill="#BBB"
                        d="M28.25 10.7a5.6 5.6 0 0 0-2.68 1.48l-.13.13-.12.13-.08.09-.15.17-.11.14-.32.43a9 9 0 0 0-.69 1.22 10 10 0 0 0-.77 2.61l-.01.03.01-.03.13-.25q.53-1.09 1.13-2.1.35-.56.74-1.08a8 8 0 0 1 .86-.97 6.4 6.4 0 0 1 2.4-1.5z"
                      />
                      <path
                        fill="#fff"
                        d="M11.73 28.63q.3-.22.61-.49a16 16 0 0 0 3.18-3.42l-2.21-.44v.01s-.33.48-2.03 2.02c-.5.45-1.06.84-1.55 1.2l-.2.14q1.05.6 2.2.98"
                      />
                      <path
                        fill="#E8E8E8"
                        d="M12.4 28.1c.17-.14.54-.44.61-.53-.03-.1.19-.37.22-.46.3-.93-.13-1.02-.24-1.47z"
                      />
                      <path
                        fill="#fff"
                        d="M20.63 28.5a13 13 0 0 1-4.62.82q-1.48 0-2.88-.3a5 5 0 0 1-.3-2.18c.13-1.77 1.1-5.26 1.1-5.26l5.96.4s.45 2.44.77 4.84a5 5 0 0 1-.03 1.68"
                      />
                      <path
                        fill="#E8E8E8"
                        d="M19.83 21.71s-1.48.87-2.24 1.1q-.13.06-.27.1l-.28.1q-.29.07-.57.16l-1.13.32q-.99.28-2.01.54l-.26 1.2h.1q1.31.01 2.56-.34a8 8 0 0 0 2.37-1.04 6 6 0 0 0 1.81-1.77z"
                      />
                      <path fill="#840000" d="m20.17 23.1-.28-1.12-5.96-.39s-.19.68-.4 1.6c1.2.4 3.93.95 6.64-.09" />
                      <path
                        fill="#E8E8E8"
                        d="M20.43 25.27c-.33.13-2.02.6-2.58.67 0 0 2.11.03 2.82 1.03a31 31 0 0 0-.24-1.7"
                      />
                      <path
                        fill="#fff"
                        d="M18.58 23.63a10 10 0 0 0 2.41-.96c1.5-.89 2.85-2.66 3.9-2.14 1.19.6-.3 2.93-3.19 4.23s-5.42 1.36-5.42 1.36"
                      />
                      <path
                        fill="#FFB8D9"
                        d="M24.09 21.03c.07.07.2.05.27-.03q.1-.15 0-.27c-.08-.07-.2-.05-.27.03s-.08.2 0 .27m.15.21a.55.55 0 0 1 .29.73.55.55 0 0 1-.71.32.55.55 0 0 1-.3-.72.55.55 0 0 1 .72-.33m.28-.02c-.07-.06-.07-.18 0-.27.07-.08.2-.1.27-.03s.08.19 0 .27a.2.2 0 0 1-.27.03m.49.16c-.08-.07-.2-.05-.27.03s-.08.2 0 .27.2.05.27-.03q.1-.15 0-.27"
                      />
                      <path
                        fill="#fff"
                        d="M2.54 20.91c1.66 5.31 18.9 6.45 20.87-5.01.16-.94.94-6.95-5.89-7.8-8.54-1.09-16.5 7.93-14.98 12.8"
                      />
                      <path fill="#C00" d="M16 17.65a1.65 1.65 0 1 0 0-3.3 1.65 1.65 0 0 0 0 3.3" />
                      <path
                        fill="#C00"
                        d="M20.95 16a4.95 4.95 0 1 1-9.9 0 4.95 4.95 0 0 1 9.9 0m-1.65 0a3.3 3.3 0 1 0-6.6 0 3.3 3.3 0 0 0 6.6 0"
                      />
                      <path d="M11.86 12.03a1.23 1.23 0 0 1-2.45-.13 1.23 1.23 0 0 1 2.45.13m4.07 5.15a1.23 1.23 0 1 0-1.15-1.29 1.23 1.23 0 0 0 1.15 1.29m-13.4 3.73a5.6 5.6 0 0 1 .2-3.44c1.69.4 4.07 1.24 5.17 3.01 1.23 1.99-1.9 2.89-4.17 2.12q-.88-.75-1.2-1.7m9.11.4q.12-.33.2-.34c.18 0-.07 2.81-2.64 3.7q-.57-.08-1.12-.18A5 5 0 0 0 10.65 23a5 5 0 0 0 1-1.7" />
                    </svg>
                    {t('questions', 'ec', 'target', 'circle')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="CircleCardPillar">
                      <path
                        fill="#C00"
                        d="M16 29.33a13.33 13.33 0 1 0 0-26.66 13.33 13.33 0 0 0 0 26.66M16 26a10 10 0 1 1 0-20 10 10 0 0 1 0 20"
                      />
                      <path
                        fill="#C00"
                        d="M10.67 11.33c-.74 0-1.34.6-1.34 1.34v6.66c0 .74.6 1.34 1.34 1.34h10.66c.74 0 1.34-.6 1.34-1.34v-6.66c0-.74-.6-1.34-1.34-1.34z"
                      />
                      <path fill="#fff" d="M11.33 16h2.34v2h-2.34z" />
                    </svg>
                    {t('questions', 'ec', 'target', 'circleCard')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Circle360Pillar">
                      <path
                        fill="#623D94"
                        d="M16 29.33a13.33 13.33 0 1 0 0-26.66 13.33 13.33 0 0 0 0 26.66M16 26a10 10 0 1 1 0-20 10 10 0 0 1 0 20"
                      />
                      <path
                        fill="#C00"
                        d="M18.33 10.67v-1L17.17 8.5h-2.34l-1.16 1.17v1h-3V14H9l.33 1h2.17a.5.5 0 0 1 0 1H8.33l.33 1h2.84a.5.5 0 0 1 0 1H9.67l.33 1h1.5a.5.5 0 0 1 0 1h-.83v2.67h10.66v-12zm-3.5-1h2.34v1h-2.34z"
                      />
                      <path fill="#fff" d="M16 17.55a.89.89 0 1 0 0-1.78.89.89 0 0 0 0 1.78" />
                      <path
                        fill="#fff"
                        d="M18.66 16.67a2.67 2.67 0 1 1-5.33 0 2.67 2.67 0 0 1 5.33 0m-.9 0a1.78 1.78 0 1 0-3.55 0 1.78 1.78 0 0 0 3.56 0"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'circle360')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.30005 3.5826C6.30005 2.70855 7.00124 2 7.86619 2H16.1339C16.9989 2 17.7 2.70855 17.7 3.5826V4.3H6.30005V3.5826ZM7.86624 22.0003C7.0013 22.0003 6.30013 21.2917 6.30013 20.4177V18.5H17.7001V20.4177C17.7001 21.2917 16.999 22.0003 16.134 22.0003H7.86624Z"
                        fill="#666666"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.30005 18.5H17.7V4.3H6.30005V18.5Z"
                        fill="#CC0000"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.7131 15.2H9.2871C8.68676 15.2 8.20007 14.7133 8.20007 14.113V8.68703C8.20007 8.08669 8.68676 7.60001 9.2871 7.60001H14.7131C15.3134 7.60001 15.8001 8.08669 15.8001 8.68703V14.113C15.8001 14.7133 15.3134 15.2 14.7131 15.2"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.0007 8.63136C10.4714 8.63136 9.23169 9.871 9.23169 11.4002C9.23169 12.9295 10.4714 14.1691 12.0007 14.1691C13.5298 14.1691 14.7695 12.9295 14.7695 11.4002C14.7695 9.871 13.5298 8.63136 12.0007 8.63136ZM12.0014 13.2457C10.9818 13.2457 10.1554 12.4192 10.1554 11.3998C10.1554 10.3803 10.9818 9.55385 12.0014 9.55385C13.0208 9.55385 13.8473 10.3803 13.8473 11.3998C13.8473 12.4192 13.0208 13.2457 12.0014 13.2457ZM12.001 12.3229C12.5108 12.3229 12.924 11.9096 12.924 11.3999C12.924 10.8902 12.5108 10.4769 12.001 10.4769C11.4913 10.4769 11.0781 10.8902 11.0781 11.3999C11.0781 11.9096 11.4913 12.3229 12.001 12.3229Z"
                        fill="#CC0000"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.0001 21.25C11.4478 21.25 11.0001 20.8023 11.0001 20.25C11.0001 19.6977 11.4478 19.25 12.0001 19.25C12.5524 19.25 13.0001 19.6977 13.0001 20.25C13.0001 20.8023 12.5524 21.25 12.0001 21.25Z"
                        fill="#333333"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'app')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Registry">
                      <path fill="#C00" d="M28.67 9.33v4h-1.34V28H4.67V13.33H3.33v-4z" />
                      <path
                        fill="#840000"
                        d="M27.33 15.33v-2H4.67v2zM17.6 7.3a31 31 0 0 1 1.65-2.03c.37-.41.94-.62 1.45-.53a1 1 0 0 1 .8.64c.18.44.15.93-.08 1.32a1.1 1.1 0 0 1-.78.57q-.37.04-.85.03zm-5 0h-.4q-.46 0-.84-.03a1.1 1.1 0 0 1-.78-.57 1.5 1.5 0 0 1-.09-1.32 1 1 0 0 1 .8-.64c.52-.09 1.09.12 1.46.53A32 32 0 0 1 14.4 7.3zm7.19 2.04c1.46 0 2.65-.32 3.4-1.62a3.6 3.6 0 0 0 .21-3.1 3 3 0 0 0-2.34-1.9 3.7 3.7 0 0 0-3.34 1.18A33 33 0 0 0 16 6.01a33 33 0 0 0-1.73-2.12 3.7 3.7 0 0 0-3.33-1.17A3 3 0 0 0 8.6 4.6a3.6 3.6 0 0 0 .21 3.1c.75 1.3 1.95 1.62 3.4 1.62z"
                      />
                      <path fill="#fff" d="M16 22a1.33 1.33 0 1 0 0-2.67A1.33 1.33 0 0 0 16 22" />
                      <path
                        fill="#fff"
                        d="M20 20.67a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.33 0a2.67 2.67 0 1 0-5.34 0 2.67 2.67 0 0 0 5.34 0"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'registry')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="SameDay">
                      <path fill="#840000" d="M11.33 3.33 13.67 1h4.66l2.34 2.33z" />
                      <path
                        fill="#C00"
                        d="M11.33 3.33v2h-6V12H2l.67 2h2.66v2H.67l.66 2h4v2h-2L4 22h1.33v7.33h21.34v-24h-6v-2L18.33 1v4.33h-4.66V1z"
                      />
                      <path
                        fill="#840000"
                        d="M5.33 16H7a1 1 0 1 0 0-2H5.33zm0 4H7a1 1 0 1 0 0-2H5.33zM7 24H5.33v-2H7a1 1 0 1 1 0 2"
                      />
                      <path fill="#fff" d="M16 19.1a1.78 1.78 0 1 0 0-3.55 1.78 1.78 0 0 0 0 3.56" />
                      <path
                        fill="#fff"
                        d="M21.33 17.33a5.33 5.33 0 1 1-10.66 0 5.33 5.33 0 0 1 10.66 0m-1.77 0a3.56 3.56 0 1 0-7.11 0 3.56 3.56 0 0 0 7.1 0"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'sameDay')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="OrderPickup">
                      <path fill="#840000" d="M11.33 3.33 13.67 1h4.66l2.34 2.33z" />
                      <path fill="#C00" d="M11.33 5.33v-2L13.67 1v4.33h4.66V1l2.34 2.33v2h6v24H5.33v-24z" />
                      <path fill="#fff" d="M16 14.22a1.56 1.56 0 1 0 0-3.11 1.56 1.56 0 0 0 0 3.11" />
                      <path
                        fill="#fff"
                        d="M20.67 12.67a4.67 4.67 0 1 0-9.34 0 4.67 4.67 0 0 0 9.34 0m-1.56 0a3.11 3.11 0 1 1-6.22 0 3.11 3.11 0 0 1 6.22 0"
                      />
                      <path
                        fill="#D6D6D6"
                        d="M21.33 21.33v1.34H10.67v-1.34S12.67 20 16 20s5.33 1.33 5.33 1.33m-6 2.67v5.33h-4.66V24zm6 5.33V24h-4.66v5.33z"
                      />
                      <path
                        fill="#840000"
                        d="M16 19.33c-3.44 0-5.33 1.26-5.33 1.26v.87S12.56 20.2 16 20.2s5.33 1.24 5.33 1.24v-.87s-1.9-1.24-5.33-1.24"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'orderPickup')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="DriveUp">
                      <path
                        fill="#333"
                        d="M11 24.67H5.67v2.81l.01.01c.06.66 1.22 1.18 2.66 1.18s2.6-.53 2.65-1.18l.01-.01zm15.33 2.81v-2.81H21v2.81c.06.66 1.22 1.19 2.66 1.19s2.6-.52 2.66-1.18z"
                      />
                      <path
                        fill="#C00"
                        d="M25.33 5.07c-4.17-2.31-14.48-2.32-18.66 0l.2.38c.36.63 1.11.9 1.8.67 3.85-1.34 10.78-1.35 14.66 0a1.5 1.5 0 0 0 1.8-.68z"
                      />
                      <path
                        fill="#C00"
                        d="M24.7 8.25c-3.81-2.11-13.58-2.11-17.4 0L6.1 12H2.67v1c0 1.33 1.4 1.67 2.33 1.67-1.37 3.26-.96 8.9.67 10h20.66c1.48-1.1 2.04-6.73.67-10 .93 0 2.33-.34 2.33-1.67v-1H25.9z"
                      />
                      <path
                        fill="#fff"
                        d="M9.33 9.96c-1.33 3.37-2 8.7-.66 12.37h14.66c1.34-3.66.67-9-.66-12.37-2.57-1.26-10.86-1.3-13.34 0"
                      />
                      <path
                        fill="#840000"
                        d="M7.02 17.13a.43.43 0 0 0-.65-.4c-1.04.65-1.73 4.33.09 4.83a.56.56 0 0 0 .7-.63c-.21-1.32-.2-2.6-.16-3.44zm18.61-.4a.43.43 0 0 0-.65.4c.06.81.1 2.27-.13 3.8-.07.4.3.73.7.63 1.8-.5 1.12-4.18.08-4.83"
                      />
                      <path
                        fill="#333"
                        d="M13.33 10c-.97 0-1.8.6-2.15 1.44l-1.18.23A24 24 0 0 0 9.63 21h12.74c.5-2.97.35-6.5-.37-9.33l-1.18-.23a2.33 2.33 0 0 0-4.08-.43h-1.49A2.3 2.3 0 0 0 13.33 10"
                      />
                      <path fill="#fff" d="M16 17.33a1.33 1.33 0 1 0 0-2.67 1.33 1.33 0 0 0 0 2.67" />
                      <path
                        fill="#fff"
                        d="M20 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.33 0a2.67 2.67 0 1 0-5.34 0 2.67 2.67 0 0 0 5.34 0"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'drive')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="TwoDayShipping">
                      <path fill="#CEAF8C" d="M2.67 24.67h18v-18h-18z" />
                      <path fill="#C00" d="M11.67 17.22a1.56 1.56 0 1 0 0-3.11 1.56 1.56 0 0 0 0 3.11" />
                      <path
                        fill="#C00"
                        d="M16.33 15.67a4.67 4.67 0 1 1-9.33 0 4.67 4.67 0 0 1 9.33 0m-1.55 0a3.11 3.11 0 1 0-6.22 0 3.11 3.11 0 0 0 6.22 0M30 20l-4.67-6.67h-4.66v11.34H30z"
                      />
                      <path
                        fill="#333"
                        d="M8 28a2.67 2.67 0 1 0 0-5.33A2.67 2.67 0 0 0 8 28m16.67 0a2.67 2.67 0 1 0 0-5.33 2.67 2.67 0 0 0 0 5.33"
                      />
                      <path fill="#fff" d="m24.5 15 2.33 3.33h-4.49V15z" />
                    </svg>
                    {t('questions', 'ec', 'target', 'free2day')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Ship">
                      <path fill="#BA9874" d="M2.67 26.67h8V5.33h-8z" />
                      <path
                        fill="#CEAF8C"
                        d="M8.67 5.33v4l-1-.66-1 .66-1-.66-1 .66v-4zm0 21.34v-4l-1 .66-1-.66-1 .66-1-.66v4zM29.33 5.33v21.34H10.67V5.33z"
                      />
                      <path fill="#C00" d="M20 17.55a1.56 1.56 0 1 0 0-3.1 1.56 1.56 0 0 0 0 3.1" />
                      <path
                        fill="#C00"
                        d="M24.67 16a4.67 4.67 0 1 1-9.34 0 4.67 4.67 0 0 1 9.34 0m-7.78 0a3.11 3.11 0 1 0 6.22 0 3.11 3.11 0 0 0-6.22 0"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'shipDeliver')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'moreServices')}</div>
                </EmptyLink>
              </div>
            </div>
          </div>
          <div className={style.imageWrapper}>
            <div className={style.image} />
          </div>
          <div className={style.belt}>
            <div className={style.inner}>
              <div className={style.networks}>
                <EmptyLink color="#CC0000">
                  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" fill="#666666" r="12"></circle>
                    <path
                      clipRule="evenodd"
                      d="M18.1902 9.11027C17.9138 6.98128 16.6484 5.54907 14.673 4.76183C13.1571 4.158 11.6032 4.19809 10.0535 4.64333C8.94768 4.96121 8.00541 5.54942 7.26145 6.436C6.49621 7.34776 6.08006 8.40463 5.96759 9.58709C5.84662 10.8579 6.15208 12.0127 6.89816 13.0486C7.14118 13.386 7.44629 13.657 7.8156 13.8515C8.0643 13.982 8.131 13.9508 8.19769 13.6815C8.25978 13.4307 8.30803 13.1753 8.38785 12.9305C8.46874 12.6811 8.46129 12.4682 8.27149 12.2681C8.19557 12.1883 8.14803 12.0783 8.09623 11.9775C7.22455 10.2927 7.68469 8.09988 9.20844 6.92487C10.6201 5.83608 12.1992 5.67785 13.8372 6.32176C14.965 6.76487 15.7008 7.62449 15.9796 8.80162C16.3188 10.2356 16.1293 11.6281 15.395 12.9141C14.9068 13.7691 14.1898 14.3332 13.1613 14.3946C12.3993 14.4397 11.705 13.9788 11.5734 13.209C11.5255 12.9283 11.5769 12.6559 11.655 12.3877C11.8511 11.7097 12.0541 11.0335 12.2474 10.3545C12.3531 9.98337 12.4149 9.60518 12.3907 9.21564C12.3404 8.40356 11.6865 7.90795 10.8954 8.09456C10.3497 8.22334 9.99604 8.59195 9.76437 9.07763C9.36135 9.9227 9.40179 10.788 9.69909 11.6526C9.74237 11.7789 9.75124 11.8928 9.72109 12.0194C9.43585 13.215 9.1797 14.418 8.86289 15.6051C8.55637 16.7524 8.41978 17.9069 8.56275 19.0854C8.5844 19.2649 8.69047 19.5846 8.69047 19.5846L9.19141 19.6906C9.20631 19.6718 9.27975 19.5381 9.35106 19.3976C9.90557 18.3085 10.3508 17.5184 10.5793 16.4626C10.6875 15.9638 10.834 15.4738 10.9663 14.9807C10.9802 14.9289 10.972 14.8519 11.0348 14.8352C11.1054 14.8164 11.121 14.897 11.1512 14.9392C11.2963 15.1428 11.48 15.3035 11.6901 15.4362C12.2471 15.7889 12.8551 15.9191 13.5118 15.8818C14.6382 15.8176 15.6121 15.3983 16.4054 14.6075C17.933 13.0851 18.4606 11.1931 18.1902 9.11027Z"
                      fill="white"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" fill="#666666" r="12"></circle>
                    <path
                      clipRule="evenodd"
                      d="M14.6777 6.81326H16.0142V3.90483L14.0012 3.90235C11.1492 3.90235 9.79605 5.59958 9.79605 8.01594V10.3049H7.56274V13.0686H9.79605V20.097H13.1458V13.0686H15.3791L16.0131 10.306H13.1458V8.41896C13.1458 7.64662 13.568 6.81326 14.6777 6.81326Z"
                      fill="white"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" fill="#666666" r="12"></circle>
                    <path
                      clipRule="evenodd"
                      d="M12.0095 5.97486C11.6889 5.97486 11.3684 5.97296 11.0478 5.97106C10.3324 5.96681 9.61694 5.96257 8.90202 5.97947C7.28426 6.01743 6.28912 6.77523 5.99502 8.16842C5.93258 8.46394 5.8861 8.7694 5.88433 9.07096C5.88243 9.45973 5.87989 9.84854 5.87735 10.2374V10.2374V10.2374C5.86708 11.8101 5.8568 13.383 5.88894 14.9549C5.92868 16.9058 6.91494 17.9491 8.797 18.0183C10.9228 18.0964 13.0518 18.09 15.1776 18.0197C16.7453 17.9679 17.6773 17.2133 17.9767 15.8585C18.0303 15.6165 18.081 15.3678 18.0824 15.122C18.0853 14.5507 18.0955 13.9792 18.1057 13.4077C18.1353 11.7423 18.165 10.0767 18.0147 8.41498C17.8951 7.09275 17.0093 6.22923 15.692 6.04865C14.8777 5.93677 14.0601 5.95225 13.2426 5.96772C12.8314 5.97551 12.4202 5.98329 12.0095 5.97486ZM4.44556 8.52107L4.45941 8.44877C4.58716 7.7817 4.71484 7.11496 5.07847 6.52193C5.93737 5.11986 7.28089 4.58168 8.82947 4.54371C10.9414 4.49227 13.0566 4.49334 15.1685 4.54478C16.6025 4.57955 17.8786 5.05175 18.7521 6.29452C19.314 7.09488 19.5234 8.01091 19.5375 8.95779C19.5684 10.9878 19.5826 13.0192 19.5358 15.0485C19.4985 16.683 18.9302 18.0776 17.3997 18.9088C16.693 19.2923 15.9182 19.4591 15.1274 19.4683C13.042 19.4924 10.9553 19.5126 8.87098 19.4651C7.30679 19.4293 5.94766 18.9014 5.07847 17.4847C4.71493 16.8918 4.58722 16.225 4.4595 15.558L4.44556 15.4853V8.52107ZM14.4532 12.0093C14.4553 10.6683 13.3516 9.56989 11.9943 9.56279C10.6458 9.5557 9.52542 10.6594 9.52329 11.9972C9.52117 13.3383 10.6249 14.4366 11.9822 14.4437C13.3304 14.4508 14.4511 13.3471 14.4532 12.0093ZM15.9055 12.0285C15.8995 14.1354 14.1508 15.8671 12.0041 15.893C9.85063 15.9189 8.06435 14.1408 8.07038 11.9781C8.07676 9.85193 9.89142 8.07345 12.0133 8.1139C14.1902 8.15505 15.9119 9.88669 15.9055 12.0285ZM16.9664 8.02651C16.9696 7.51422 16.5297 7.08388 16.0103 7.09062C15.4768 7.09736 15.0539 7.51918 15.0631 8.03502C15.0723 8.54554 15.5215 8.96807 16.0391 8.95317C16.5425 8.93863 16.964 8.51787 16.9664 8.02651Z"
                      fill="white"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" fill="#666666" r="12"></circle>
                    <path
                      d="M13.15 11.2 17.6 6H16.55L12.65 10.5 9.55 6H6L10.7 12.8 6 18.25H7.05L11.15 13.5 14.45 18.25H18L13.15 11.2H13.15ZM11.7 12.9 11.2 12.2 7.45 6.8H9.05L12.1 11.15 12.6 11.85 16.55 17.5H14.9L11.7 12.9V12.9Z"
                      fill="white"
                    ></path>
                  </svg>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" fill="#666666" r="12"></circle>
                    <path
                      clipRule="evenodd"
                      d="M14.4924 12.3947L10.9515 14.1065C10.6666 14.2441 10.3359 14.0366 10.3359 13.7201V10.375C10.3359 10.0621 10.6602 9.85451 10.9444 9.98578L14.4853 11.6191C14.6226 11.6827 14.7 11.8011 14.7237 11.9289C14.7386 11.9647 14.7386 12.0016 14.7305 12.0381C14.7209 12.1818 14.6436 12.3216 14.4924 12.3947ZM11.9964 5.95699C4.28325 5.95699 4.14844 6.64276 4.14844 11.9998C4.14844 17.3565 4.28325 18.0427 11.9964 18.0427C19.7091 18.0427 19.8439 17.3565 19.8439 11.9998C19.8439 6.64276 19.7091 5.95699 11.9964 5.95699Z"
                      fill="white"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" fill="#666666" r="12"></circle>
                    <path
                      d="M18.0201 9.18155V10.8064C17.254 10.8067 16.5095 10.6565 15.8074 10.3603C15.356 10.1697 14.9354 9.92414 14.5507 9.62737L14.5622 14.6286C14.5574 15.7548 14.1118 16.8129 13.3054 17.6099C12.6492 18.2587 11.8176 18.6712 10.9163 18.8048C10.7045 18.8361 10.489 18.8522 10.271 18.8522C9.30621 18.8522 8.39023 18.5396 7.64093 17.963C7.49993 17.8544 7.36507 17.7367 7.23668 17.6099C6.36274 16.7461 5.91209 15.5755 5.98798 14.3439C6.04587 13.4065 6.4212 12.5124 7.04689 11.8117C7.8747 10.8844 9.03279 10.3697 10.271 10.3697C10.489 10.3697 10.7045 10.3861 10.9163 10.4175V11.0182V12.6894C10.7155 12.6232 10.5011 12.5867 10.2777 12.5867C9.14646 12.5867 8.23123 13.5097 8.24815 14.6418C8.25889 15.3662 8.65456 15.9994 9.23815 16.3484C9.51242 16.5125 9.82793 16.6141 10.1646 16.6326C10.4284 16.647 10.6818 16.6103 10.9163 16.5329C11.7246 16.2659 12.3077 15.5067 12.3077 14.6113L12.3103 11.2622V5.14781H14.548C14.5501 5.36953 14.5726 5.58586 14.6144 5.79548C14.7833 6.64397 15.2616 7.38009 15.9272 7.88194C16.5076 8.3197 17.2303 8.5792 18.0137 8.5792L18.0201 8.57869L18.0201 9.18155Z"
                      fill="white"
                    ></path>
                  </svg>
                </EmptyLink>
              </div>
              <div className={style.links}>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'terms')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'ca')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'privacy')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'caPrivacy')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="CCPA">
                      <path fill="#1A75FF" d="M1.5 12a5 5 0 0 1 5-5h11a5 5 0 0 1 0 10h-11a5 5 0 0 1-5-5" />
                      <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M6.5 8h7l-2 8h-5a4 4 0 0 1 0-8m12.44 2.4a.44.44 0 0 0 0-.59.44.44 0 0 0-.59 0l-1.6 1.6-1.6-1.6a.44.44 0 0 0-.6 0 .44.44 0 0 0 0 .58L16.17 12l-1.53 1.6a.44.44 0 0 0 0 .6.44.44 0 0 0 .59 0l1.6-1.62 1.6 1.61a.44.44 0 0 0 .6 0 .44.44 0 0 0 0-.58L17.4 12z"
                        clipRule="evenodd"
                      />
                      <path
                        fill="#1A75FF"
                        d="M10.34 9.88c.15.14.22.44.08.58l-3.07 3.58c-.07.07-.14.15-.22.15a.5.5 0 0 1-.5-.08L5 12.51a.44.44 0 0 1 0-.59.44.44 0 0 1 .59 0l1.31 1.24 2.8-3.28c.14-.15.43-.15.65 0"
                      />
                    </svg>
                    {t('questions', 'ec', 'target', 'privacyChoice')}
                  </div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'based')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'health')}</div>
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.link}>{t('questions', 'ec', 'target', 'tm')}</div>
                </EmptyLink>
              </div>
            </div>
          </div>
        </footer>
      )}
    </>
  )
}

export default Footer
